import type { Connector } from "wagmi";
import { Modal } from "./Modal";
import { useT } from "../lib/i18n";

/**
 * Selector de wallet. Nace de un bug real: con VARIAS extensiones instaladas (Rabby + MetaMask…),
 * el conector `injected()` genérico apunta a `window.ethereum`, que ya no es de nadie en concreto —
 * Rabby, cuando no es la wallet por defecto, se inyecta SOLO por EIP-6963 y no ocupa
 * `window.ethereum`. Resultado: `connect()` no encontraba proveedor y fallaba EN SILENCIO, así que
 * «Empezar a ganar» no hacía nada.
 *
 * Aquí se listan los proveedores que el navegador ANUNCIA por EIP-6963 (cada uno con su nombre e
 * icono) para que el usuario elija el suyo, y —crucial— si algo falla, el error SE VE.
 */
export function ElegirWallet({
  abierto, cerrar, wallets, conectar, conectando, error,
}: {
  abierto: boolean;
  cerrar: () => void;
  wallets: readonly Connector[];
  conectar: (c: Connector) => void;
  conectando: boolean;
  error?: { shortMessage?: string; message: string } | null;
}) {
  const t = useT();
  const msg = error ? (error.shortMessage || error.message) : "";
  return (
    <Modal abierto={abierto} cerrar={cerrar} titulo={t("Elige tu wallet")} ancho={420}>
      {wallets.length === 0 ? (
        <p className="detalle">
          {t("No detectamos ninguna wallet en este navegador. Instala MetaMask o Rabby (o activa la extensión) y recarga la página.")}
        </p>
      ) : (
        <div className="lista-wallets">
          {wallets.map((w) => (
            <button
              key={w.uid}
              className="btn fantasma fila-wallet"
              disabled={conectando}
              onClick={() => conectar(w)}
            >
              {w.icon && <img src={w.icon} alt="" width={26} height={26} style={{ borderRadius: 6 }} />}
              <span>{w.name}</span>
            </button>
          ))}
        </div>
      )}
      {msg && (
        <p className="detalle error" style={{ marginTop: 12 }}>
          {t("No se pudo conectar")}: {msg}
        </p>
      )}
    </Modal>
  );
}
